<template>
  <!-- A risk score coloured by its band, with the band's name (US 9370) -->
  <span class="rk-score" :class="['is-' + (band || 'none'), { 'is-small': small }]">
    <i>{{ value || '–' }}</i>
    <small v-if="!small && band">{{ $t('risk_tab.bands.' + band) }}<template v-if="note"><br><span :class="{ 'is-warn': warn }">{{ note }}</span></template></small>
  </span>
</template>

<script>
  export default {
    name: 'RiskScore',
    props: {
      value: { type: Number, default: null },
      band: { type: String, default: null },
      note: { type: String, default: '' },
      warn: { type: Boolean, default: false },
      small: { type: Boolean, default: false }
    }
  }
</script>
